import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ChartBarIcon as ChartBar } from "@phosphor-icons/react";

/** Descriptive local market ranges — informational only, never a
 * recommendation. Provider-side only. */
export default function PricingInsights() {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/providers/mine/pricing-insights").then((r) => setD(r.data)).catch(() => setD(null));
  }, []);

  if (!d || d.scope === "none") return null;
  return (
    <div className="bg-white border border-[#EAEAEA] rounded-xl p-6 mt-6" data-testid="pricing-insights">
      <h2 className="font-spectral text-2xl tracking-tight mb-1 flex items-center gap-2">
        <ChartBar size={20} weight="duotone" className="text-gold" /> Market snapshot
      </h2>
      <p className="text-[12.5px] text-[#6B6B6B] mb-4">
        What other {d.kind}s {d.scope === "local" ? `in ${d.state}` : "nationally"} have set for their services.
      </p>
      <div className="flex items-end gap-6 flex-wrap">
        <Stat label="25th percentile" value={d.p25} />
        <Stat label="Typical (median)" value={d.median} big />
        <Stat label="75th percentile" value={d.p75} />
        <p className="text-[11px] text-[#9A9A9A] self-center">Based on {d.count} listed services</p>
      </div>
      <p className="text-[10.5px] text-[#9A9A9A] mt-4 leading-relaxed border-t border-[#F0F0F0] pt-3">
        Shown for information only, based on prices set by other providers. Armstrong K9 Registry does not set,
        recommend, or guarantee prices. You alone decide what to charge.
      </p>
    </div>
  );
}

function Stat({ label, value, big }) {
  return (
    <div>
      <p className={`font-spectral text-ink font-tabular ${big ? "text-3xl" : "text-xl text-[#6B6B6B]"}`}>${value.toFixed(0)}</p>
      <p className="text-[10px] uppercase tracking-wider text-[#6B6B6B]">{label}</p>
    </div>
  );
}
